/**
 * Console shim to suppress console.log/info/debug in production builds
 * while preserving console.warn and console.error for actionable runtime errors.
 *
 * In production: log/info/debug are no-ops; warn/error pass through.
 * In non-production: all console methods pass through normally.
 */

const isProduction = process.env.NODE_ENV === 'production';

if (isProduction) {
  // Store original console methods
  const originalLog = console.log;
  const originalInfo = console.info;
  const originalDebug = console.debug;
  const originalWarn = console.warn;
  const originalError = console.error;

  // Override log/info/debug to be no-ops in production
  // Use Object.defineProperty to ensure the override works even if console is frozen
  try {
    Object.defineProperty(console, 'log', {
      value: () => {},
      writable: false,
      configurable: false,
    });

    Object.defineProperty(console, 'info', {
      value: () => {},
      writable: false,
      configurable: false,
    });

    Object.defineProperty(console, 'debug', {
      value: () => {},
      writable: false,
      configurable: false,
    });

    // Ensure warn and error still work (they should already, but being explicit)
    Object.defineProperty(console, 'warn', {
      value: originalWarn,
      writable: false,
      configurable: false,
    });

    Object.defineProperty(console, 'error', {
      value: originalError,
      writable: false,
      configurable: false,
    });
  } catch (e) {
    // Fallback: if Object.defineProperty fails, try direct assignment
    // This can happen in some environments where console is frozen
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};
    // warn and error should already be preserved
  }
}

// In non-production, do nothing - all console methods work normally
// This file is still imported to ensure consistent behavior across environments
